import { Typography } from '../../common/typography'
import NearlyThere from '../../assets/nearly-there.png'
import Platinum from '../../assets/platinum.png'
import Gold from '../../assets/gold.png'
import Silver from '../../assets/silver.png'
import Bronze from '../../assets/bronze.png'
import { AspectRatio, Image } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import classes from './LearningComponents.module.css'

const LevelIcon: Record<string, string> = {
  Platinum,
  Gold,
  Silver,
  Bronze,
  'Nearly there': NearlyThere,
}

function WaveLoader() {
  return (
    <svg
      className={classes.waveLoader}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeOpacity="0"
        strokeWidth="1.5"
      >
        <animate
          attributeName="r"
          begin="0s"
          dur="3s"
          values="20;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-opacity"
          begin="0s"
          dur="3s"
          values="0.6;0"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeOpacity="0"
        strokeWidth="1.5"
      >
        <animate
          attributeName="r"
          begin="1s"
          dur="3s"
          values="20;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-opacity"
          begin="1s"
          dur="3s"
          values="0.6;0"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeOpacity="0"
        strokeWidth="1.5"
      >
        <animate
          attributeName="r"
          begin="2s"
          dur="3s"
          values="20;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-opacity"
          begin="2s"
          dur="3s"
          values="0.6;0"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}

export default function LearningLevel({
  level,
  component,
}: {
  level: 'Platinum' | 'Gold' | 'Silver' | 'Bronze' | 'Nearly there'
  component?: string
}) {
  const isMobile = useMediaQuery('(max-width: 800px)')
  const src = LevelIcon[level]

  return (
    <div className={classes.learningLevelContainer}>
      <div className={classes.iconWrapper}>
        <WaveLoader />
        <AspectRatio
          className={classes.levelIcon}
          data-mobile={isMobile || component === 'team'}
        >
          <Image src={src} fit="scale-down" />
        </AspectRatio>
      </div>
      <Typography
        fw={500}
        fc={{ light: 'black', dark: 'gray-2' }}
        lh="120"
        className={classes.teamWrapper}
      >
        Learning XP&nbsp;Level:{' '}
        <Typography
          fw={700}
          fs="xl"
          fc={{ light: 'black', dark: 'gray-2' }}
          lh="120"
        >
          {level === 'Nearly there' ? 'Provisional' : level}
        </Typography>
      </Typography>
    </div>
  )
}
